<ng-container
  *ngTemplateOutlet="
    groupContainer;
    context: {
      $implicit: {
        type: 'global',
        title: 'Global Tasks',
        views: globalTasksViews$ | async,
        isLoading: isLoading().globalTasks,
        icon: 'ts_list-ul',
        url: '/new-tasks/Account/' + account.id,
      },
    }
  "
></ng-container>
<ng-container
  *ngTemplateOutlet="
    groupContainer;
    context: {
      $implicit: {
        type: 'aggregated',
        title: 'Aggregated Tasks',
        views: aggregatedTasksViews$ | async,
        isLoading: isLoading().aggregatedTasks,
        icon: 'ts_list-ul',
        url: '/new-tasks/AggregatedTasks/' + account.id,
      },
    }
  "
></ng-container>
<ng-template #groupContainer let-data>
  <div class="group">
    <div class="header">
      <ts-icon [icon]="data.icon" size="small" class="info-icon"></ts-icon> <span>{{ data.title }}</span>
      <ts-icon
        icon="open_in_new"
        size="small"
        class="navigate-icon"
        [routerLink]="data.url"
        (click)="onNavigate.emit()"
      ></ts-icon>
    </div>
    <ts-divider spacing="none"></ts-divider>
    <div class="saved-views-group">
      <ts-icon [icon]="'ts_window-section'" iconColor="black"></ts-icon>
      {{ data.type === 'aggregated' ? 'Saved Views' : 'Task Lists' }}
      @if (data.type === 'aggregated' ? (canCreateAggregated$ | async) : (canCreateGlobal$ | async)) {
        <ts-button
          type="icon"
          icon="ts_plus"
          iconColor="black"
          (buttonClick)="openNewViewDialog(data.type)"
        ></ts-button>
      }
    </div>
    <ts-tree-menu
      sidenav
      [suppressHeader]="true"
      [items]="data.views ?? []"
      [loading]="data.isLoading"
      [delegateLeafClickFn]="delegateLeafClickFn.bind(this)"
      [smallSkeleton]="true"
    ></ts-tree-menu>
  </div>
</ng-template>
